<script>
import {httpAction, postAction} from "@/utils/api/manages";

export default {
  name: "list",
  props: {
    listData: Array,
    total: Number,
    pageCurrent: Number,
    type: String,
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  created() {
  },
  data() {
    return {
      userInfo: {}
    }
  },
  methods: {
    // 关注
    concern(item) {
      if (!this.checkLogin()) return
      const {productId} = item
      httpAction({
        url: `/product/care/${productId}/${this.userInfo.userId}`,
        method: 'post',
        noToken: true,
      }).then(res => {
        if (res.code === 200) {
          layer.alert('关注成功！', {icon: 6})
          item.careNum += 1
        } else {
          // layer.alert('关注失败！', {icon: 6})
        }
      })
    },
    // 点评
    comment(item) {
      const {productId} = item
      const pageIndex = this.type === '1' ? 2 : 3
      this.$router.push(`/product-info${pageIndex}?productId=${productId}#news`)

    },
    // 咨询
    ask(item) {
      $('#contactModal').modal("show")
    },
    // 检查当前用户是否登录
    checkLogin() {

      let authData = localStorage.getItem("authdata")
      if (!authData) {
        layer.alert('用户未登陆，请<a class="mydarkred" href="/register">注册</a>并登录', {icon: 6})
        return false
      }
      this.userInfo = JSON.parse(authData).data
      return true
    },
    pageChange(page) {
      this.$emit('currenChange', page)
    },
    goInfoPage(item) {
      const {productId} = item
      if (this.type === '1') {
        this.$router.push(`/product-info2?productId=${productId}&type=${this.type}`)
      } else {
        this.$router.push(`/product-info3?productId=${productId}&type=${this.type}`)
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="list">
      <template v-if="listData.length">
        <div class="card" v-for="(item,index) in listData" @click="goInfoPage(item)">
          <div class="card-body">
            <div class="card-img">
              <el-image :src="item.productImages" fit="contain"
                        style="width: 102px; height: 67px"></el-image>
            </div>
            <div class="card-info">
              <h4 class="title" :title="item.productName">{{ item.productName }}</h4>
              <div class="info-score">
                <div>
                  <span class="layui-icon layui-icon-star-fill stars"></span>
                  <span class="score">{{ item.totalScore.toFixed(1) }}分</span>
                </div>
                <el-divider direction="vertical" style="margin: 0 5px"></el-divider>
                <div class="comments">
                  <span>评论</span>
                  <span>{{ item.commentNumber }}</span>
                </div>
              </div>
              <div class="info-company">
                <div class="company">
                  <span class="el-icon-box"></span>
                  <span :title="item.productFactory">
                  {{ item.productFactory }}
                </span>
                </div>
                <div>
                  <span class="see"><i class="el-icon-view" style="margin-right:2px"></i>{{ item.hitNum }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="buttonGroups">
              <div class="myBtn el-icon-plus" @click.stop="concern(item)">关注</div>
              <div class="myBtn isBorder el-icon-edit-outline" @click.stop="comment(item)">点评</div>
              <div class="myBtn el-icon-chat-dot-round" @click.stop="ask(item)">咨询</div>
            </div>
          </div>
        </div>
      </template>
      <div class="empty" v-else>
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
    <div style="text-align: center" v-if="showPagination">
      <el-pagination class="pagination" @current-change="pageChange" :current-page=pageCurrent background
                     layout="total, prev, pager, next, jumper" :total="total" :page-size="40">
      </el-pagination>
    </div>
  </div>

</template>

<style scoped lang="scss">
.list {
  // 声明为容器（父级元素）
  container-type: inline-size;
  container-name: product-list;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  overflow: hidden;
  gap: 12px;
}

.card {

  background-color: #fff;
  width: calc((100% - 36px) / 4);
  box-sizing: border-box;
  border: 1px solid transparent;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;

  @container product-list (max-width: 900px) {
    width: calc((100% - 24px) / 3) !important;
  }

  &:hover {
    border-color: rgb(2, 98, 241);
  }

  &:hover .title {
    color: #eb5412 !important;
  }

  .card-body {
    display: flex;
    gap: 15px;
    padding: 15px 20px;


    .card-img {
      border-radius: 4px;
      border: 1px solid #eee;
      overflow: hidden;
      width: 102px;
      flex-shrink: 0;
    }

    .card-info {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .title {
        font-size: 18px;
        font-weight: 500;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 20px;
        color: #232f3e;
        width: 130px;

        &:hover {
          color: var(--swiper-theme-color);
        }
      }

      .info-score {
        display: flex;
        align-items: center;
        justify-content: space-between;


        .stars {
          display: inline-block;
          width: 18px;
          height: 18px;
          background-color: #FF702D;
          color: #ffffff;
          text-align: center;
          line-height: 18px;
          font-size: 14px;
          border-radius: 3px;
        }

        .score {
          color: var(--swiper-theme-color);
          padding-left: 4px;
        }

        .comments {
          font-size: 12px;
          color: #999999;
        }

      }

      .info-company {
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        color: #666666;
        align-items: center;

        .company {
          display: inline-block;
          width: 90px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .see {
          color: #999999;
        }
      }
    }

  }

  .card-footer {
    border-top: 1px solid #eee;

    .buttonGroups {
      display: flex;

      .myBtn {
        flex: 1;
        text-align: center;
        line-height: 38px;
        color: var(--swiper-theme-color);
      }

      .isBorder {
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
      }
    }
  }
}

.pagination {
  margin: 20px auto;
}

.empty {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
<style lang="scss">
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: #ffffff;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #eb5412;
  color: #FFFFFF;
}

.el-pagination .el-pager li:not(.disabled):hover {
  color: #eb5412;
}
</style>